export default __webpack_public_path__ + "static/media/personality_INFp.ae932951.png";